/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/logs/batch_details" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdLogsBatchDetails } from "./constants";
import type { GenerativeAiAgentIdLogsBatchDetailsResult } from "./types";
import { isGenerativeAiAgentIdLogsBatchDetailsResult } from "./validators";

export const getGenerativeAiAgentIdLogsBatchDetails = reactQueryFetcherAdapter(
  generativeAiAgentIdLogsBatchDetails,
  (
    signal: AbortSignal,
    id: string,
    invocationIds: string[]
  ): Promise<GenerativeAiAgentIdLogsBatchDetailsResult> => {
    return fetch(
      `/generative_ai/agent/${id}/logs/batch_details`,
      "GET",
      { invocation_ids: invocationIds },
      { signal }
    );
  },
  isGenerativeAiAgentIdLogsBatchDetailsResult
);
